import { create } from 'zustand';

const useMessagesStore = create((set) => ({
  currentMessages: [], // Default value as an empty array
  setMessageList: (newMessages) => set({ discussions: newMessages || [] }), // Ensure newDiscussions is always an array
}));

export default useMessagesStore;
